import React from 'react';
import './styles.scss';
import loaderIcon from './../lincoln.svg';
import { LoaderProps } from '..';

const FullPageLoader: React.FunctionComponent<LoaderProps> = (
  props: LoaderProps
) => {
  return (
    <div className="Loader FullLoader">
      <div className="FullLoader__icon">
        <img src={loaderIcon} alt=".."></img>
      </div>
      {props.text && <div className="FullLoader__text">{props.text}</div>}
    </div>
  );
};

export default FullPageLoader;
